export type TaskTemplatingType = "NONE" | "PREDEFINED" | "USER_CUSTOM";

export enum ReportType {
    SCHEDULED = "SCHEDULED",
    MANUAL = "MANUAL"
}

export enum ReportStatus {
    QUEUED = "QUEUED", // smelio laikrodis
    SUCCESS = "SUCCESS", // zalias checkmark
    GENERATING = "GENERATING", // progressspiner
    FAILED = "FAILED", // raudonas iksas
    FAILED_RETRYING = "FAILED_RETRYING", // geltonas trikampis sauktukas
    MARKED_FOR_REGENERATION = "MARKED_FOR_REGENERATION", //

}

export enum TaskTemplateInputSubType {
    STRING = "STRING",
    NUMBER = "NUMBER",
    DATE = "DATE",
    BOOLEAN = "BOOLEAN",
}

export enum TaskTemplateInputType {
    CONSTANT = "CONSTANT",
    PRODUCT_TEMPLATE = "PRODUCT_TEMPLATE",
    DATASET_PAIRS = "DATASET_PAIRS",

    INPUT_INDEXED_DATASETS = "INPUT_INDEXED_DATASETS",
    INPUT_NAMED_DATASET = "INPUT_NAMED_DATASET",
    INPUT_NAMED_CATEGORY = "INPUT_NAMED_CATEGORY",

    OUTPUT_INDEXED_DATASETS = "OUTPUT_INDEXED_DATASETS",
    OUTPUT_NAMED_DATASET = "OUTPUT_NAMED_DATASET",
    OUTPUT_NAMED_CATEGORY = "OUTPUT_NAMED_CATEGORY",

    FREESTYLE_JSON = "FREESTYLE_JSON",

    COMMENT = "COMMENT"
}

export enum TaskTemplateInputGroupType {
    SIMPLE = "SIMPLE",
    GROUPED = "GROUPED",
}

export enum DatasetType {
	SIMPLE_DATASET = 'SIMPLE_DATASET',
	ADVANCED_DATASET = 'ADVANCED_DATASET',
	CATEGORIZED_DATASET = 'CATEGORIZED_DATASET',
	ELECTRICITY_DATASET = 'ELECTRICITY_DATASET',
	PROCESSED_DATASET = 'PROCESSED_DATASET',
	PROCESSED_INTEGRAL_DATASET = 'PROCESSED_INTEGRAL_DATASET',
	PROCESSED_PRIORITY_FIRST_DATASET = 'PROCESSED_PRIORITY_FIRST_DATASET',
	PROCESSED_PYTHON_DATASET = 'PROCESSED_PYTHON_DATASET',
	REMOTE_CATEGORIZED_DATASET = 'REMOTE_CATEGORIZED_DATASET',
}

export type AirflowWorkerQueue = "DEFAULT" | "FAST_COMPUTE";
export type ChronoUnitStr = "SECONDS" | "HOURS" | "DAYS" | "MONTHS" | "WEEKS";